import { hooks } from "./hookactions"
export let SYSEPT = { hooks }
